import {PERMISSIONS} from './APP_CONSTANTS';

export const SALES_REP_PERMISSIONS = [
    PERMISSIONS.view_only_rebuild_book_button,
    PERMISSIONS.view_only_save_changes_button,
    PERMISSIONS.view_only_send_to_pdh,
    PERMISSIONS.view_only_view_pdf_log,
    PERMISSIONS.view_only_send_to_etext,
    PERMISSIONS.view_only_send_to_vitalsource,
    PERMISSIONS.hide_etext_status_log,
    PERMISSIONS.hide_etext_invite_instructor,
    PERMISSIONS.view_only_etext_student_subcription_length,
    PERMISSIONS.view_only_acess_code_ISBN_button,
    PERMISSIONS.view_only_SPWAccessCode,
    PERMISSIONS.view_only_etext_access_code_student_length,
    PERMISSIONS.view_only_send_access_code_to_pdh,
    PERMISSIONS.view_only_send_access_code_to_etext,
    PERMISSIONS.view_only_student_subcription_length,
    PERMISSIONS.view_only_vitalsource_student_invite_link,
    PERMISSIONS.hide_vitalsource_log,
    PERMISSIONS.hide_vitalsource_invite_instructor,
    PERMISSIONS.view_only_comp_code_button,
    PERMISSIONS.view_only_collection_title,
    PERMISSIONS. view_only_add_notes, 
    PERMISSIONS.view_only_toc_numeration,
    PERMISSIONS.view_only_forced_trim_size,
    PERMISSIONS.view_only_automatic_page_numbering,
    PERMISSIONS.view_only_automatic_indexes,
    PERMISSIONS.view_only_chapter_headers,
    PERMISSIONS.view_only_binding_type,
    PERMISSIONS.view_only_forced_recto_start,
    PERMISSIONS.view_only_instructor_has_requested_access_codes,
    PERMISSIONS.view_only_trim_size,
    PERMISSIONS.view_only_pricing,
    PERMISSIONS.view_only_org_unit,
    PERMISSIONS.view_only_course_name,
    PERMISSIONS.view_only_course_number,
    PERMISSIONS.view_only_estimated_enrollment,
    PERMISSIONS.view_only_class_startdate,
    PERMISSIONS.view_only_class_enddate,
    PERMISSIONS.view_only_draggable,
    PERMISSIONS.view_only_delete_chapter,
    PERMISSIONS.hide_add_content,
    PERMISSIONS.hide_add_om,
    PERMISSIONS.view_only_instructor_change,
    PERMISSIONS.view_only_institution_change,
    PERMISSIONS.hide_adding_part,
    PERMISSIONS.view_only_delete_part,
    PERMISSIONS.view_only_part_title,
    PERMISSIONS.view_only_table_draggable,
    PERMISSIONS.hide_only_pdflinks,
    PERMISSIONS.view_only_cover_design,
];

export const LSA_PREMISSIONS = [
  
];

export const PROJECT_SPECIALIST_PERMISSIONS = [   

];



// WEBPACK FOOTER //
// ./src/constants/permissionsConstants.js